import { appRoutes, canManageFiduciarie, useAppSelector } from 'azshared';
import { Navigate, Outlet } from 'react-router-dom';

// The fiduciarie pages are reachable by URL too: without the SAML group the user goes back to the dashboard.
export const FiduciarieRouteGuard = () => {
  const allowed = useAppSelector((state) => canManageFiduciarie(state.features.adminConsole.common.user));
  return allowed ? <Outlet /> : <Navigate to={appRoutes.AdminDashboard} replace />;
};
